import layouts from '../../../../../../.helix/layouts.js';

export default [
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminDashboard }) => HAdminDashboard),
  },
  {
    path: '/admin/logs',
    name: 'admin-logs',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminLogs }) => HAdminLogs),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error404',
    meta: { authenticate: false, layout: layouts['blank-layout'] },
    component: () => import('@onify/helix-pages').then(({ HLegacyError404 }) => HLegacyError404),
  },
  {
    path: '/error',
    name: 'error',
    meta: { authenticate: false, layout: layouts['blank-layout'] },
    component: () => import('@onify/helix-pages').then(({ HLegacyError }) => HLegacyError),
  },
  {
    path: '/workspaces',
    name: 'workspaces',
    meta: { authenticate: true },
    component: () => import('@onify/helix-pages').then(({ HWorkspacesList }) => HWorkspacesList),
  },
  {
    path: '/workspaces/:workspaceSlug',
    name: 'workspace',
    meta: { authenticate: true },
    component: () => import('@onify/helix-pages').then(({ HWorkspace }) => HWorkspace),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: { authenticate: false, layout: layouts['blank-layout'] },
    component: () => import('@onify/helix-pages').then(({ HLogout }) => HLogout),
  },
  {
    path: '/login/internal',
    name: 'login-internal',
    meta: { authenticate: false, layout: layouts['blank-layout'] },
    component: () => import('@onify/helix-pages').then(({ HLoginInternal }) => HLoginInternal),
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    meta: { authenticate: true, layout: layouts['blank-layout'] },
    component: () => import('@onify/helix-pages').then(({ HMaintenance }) => HMaintenance),
  },
  {
    path: '/admin/roles',
    name: 'admin-roles',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminRoles }) => HAdminRoles),
  },
  {
    path: '/admin/locales',
    name: 'admin-locales',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminLocales }) => HAdminLocales),
  },
  {
    path: '/admin/strings',
    name: 'admin-strings',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminStrings }) => HAdminStrings),
  },
  {
    path: '/admin/agents',
    name: 'admin-agents',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminAgents }) => HAdminAgents),
  },
  {
    path: '/examples',
    name: 'examples',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/index.vue'),
  },
  {
    path: '/test/dialog-link',
    name: 'test-dialog-link',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-dialog-link.vue'),
  },
  {
    path: '/test/bulletins',
    name: 'test-bulletins',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-bulletins.vue'),
  },
  {
    path: '/test/live-search',
    name: 'use-live-search',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-useLiveSearch.vue'),
  },
  {
    path: '/test/validate',
    name: 'validators',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-validate.vue'),
  },
  {
    path: '/test/bind-query-params',
    name: 'bind-query-params',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-useBindQueryParams.vue'),
  },
  {
    path: '/test/alerts',
    name: 'alerts',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-alerts.vue'),
  },
  {
    path: '/test/translations',
    name: 'translations',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-translations.vue'),
  },
  {
    path: '/test/forms',
    name: 'forms',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-forms.vue'),
  },
  {
    path: '/test/data-store',
    name: 'data-store',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-dataStore.vue'),
  },
  {
    path: '/test/shortcuts',
    name: 'test-shortcuts',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-shortcuts.vue'),
  },
  {
    path: '/test/items',
    name: 'test-items',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-items.vue'),
  },
  {
    path: '/test/vuetify-components',
    name: 'test-vuetify-components',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-vuetify-components.vue'),
  },
  {
    path: '/test/tables',
    name: 'test-tables',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-tables.vue'),
  },
  {
    path: '/test/loader',
    name: 'test-loader',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-loader.vue'),
  },
  {
    path: '/test/cards',
    name: 'test-cards',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-cards.vue'),
  },
  {
    path: '/test/form-page',
    name: 'test-form-page',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-form-page.vue'),
  },
  {
    path: '/test/layout-container',
    name: 'test-layout-container',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-layout-container.vue'),
  },
  {
    path: '/test/process-state',
    name: 'test-process-state',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-process-state.vue'),
  },
  {
    path: '/test/search-items',
    name: 'test-search-items',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-search-items/index.vue'),
  },
  {
    path: '/test/theme',
    name: 'test-theme',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-theme.vue'),
  },
  {
    path: '/test/notification',
    name: 'test-notification',
    meta: { authenticate: true, layout: layouts['basic-layout'] },
    component: () => import('/src/examples/pages/test-notification.vue'),
  },
  {
    path: '/admin/audit',
    name: 'admin-audit',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminAudit }) => HAdminAudit),
  },
  {
    path: '/admin/processes',
    name: 'admin-processes',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminProcesses }) => HAdminProcesses),
  },
  {
    path: '/admin/bulletins',
    name: 'admin-bulletins',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminBulletins }) => HAdminBulletins),
  },
  {
    path: '/admin/domains',
    name: 'admin-domains',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminDomains }) => HAdminDomains),
  },
  {
    path: '/admin/dashboards',
    name: 'admin-dashboards',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminDashboards }) => HAdminDashboards),
  },
  {
    path: '/admin/forms',
    name: 'admin-forms',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminForms }) => HAdminForms),
  },
  {
    path: '/admin/guides',
    name: 'admin-guides',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminGuides }) => HAdminGuides),
  },
  {
    path: '/admin/items',
    name: 'admin-items',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminItems }) => HAdminItems),
  },
  {
    path: '/admin/options',
    name: 'admin-options',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminOptions }) => HAdminOptions),
  },
  {
    path: '/admin/settings',
    name: 'admin-settings',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminSettings }) => HAdminSettings),
  },
  {
    path: '/admin/shortcuts',
    name: 'admin-shortcuts',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminShortcuts }) => HAdminShortcuts),
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminUsers }) => HAdminUsers),
  },
  {
    path: '/admin/workflows',
    name: 'admin-workflows',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminWorkflows }) => HAdminWorkflows),
  },
  {
    path: '/admin/workspaces',
    name: 'admin-workspaces',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminWorkspaces }) => HAdminWorkspaces),
  },
  {
    path: '/admin/system-logs',
    name: 'admin-system-logs',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminSystemLogs }) => HAdminSystemLogs),
  },
  {
    path: '/admin/resources',
    name: 'admin-resources',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminResources }) => HAdminResources),
  },
  {
    path: '/admin/connector/pipelines',
    name: 'admin-connector-pipelines',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminConnectorPipelines }) => HAdminConnectorPipelines),
  },
  {
    path: '/admin/connector/datasource/file',
    name: 'admin-connector-datasource-file',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminConnectorDatasourceFile }) => HAdminConnectorDatasourceFile),
  },
  {
    path: '/admin/connector/datasource/ldap',
    name: 'admin-connector-datasource-ldap',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminConnectorDatasourceLdap }) => HAdminConnectorDatasourceLdap),
  },
  {
    path: '/admin/connector/datasource/rest',
    name: 'admin-connector-datasource-rest',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminConnectorDatasourceRest }) => HAdminConnectorDatasourceRest),
  },
  {
    path: '/admin/connector/datasource/sql',
    name: 'admin-connector-datasource-sql',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminConnectorDatasourceSql }) => HAdminConnectorDatasourceSql),
  },
  {
    path: '/admin/connector/tasks/index',
    name: 'admin-connector-index',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminConnectorIndex }) => HAdminConnectorIndex),
  },
  {
    path: '/admin/connector/tasks/purge',
    name: 'admin-connector-purge',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminConnectorPurge }) => HAdminConnectorPurge),
  },
  {
    path: '/admin/connector/tasks/reader',
    name: 'admin-connector-reader',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminConnectorReader }) => HAdminConnectorReader),
  },
  {
    path: '/admin/connector/tasks/script',
    name: 'admin-connector-script',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminConnectorScript }) => HAdminConnectorScript),
  },
  {
    path: '/admin/connector/tasks/transform',
    name: 'admin-connector-transform',
    meta: { authenticate: true, layout: layouts['helix-layout'] },
    component: () => import('@onify/helix-pages').then(({ HAdminConnectorTransform }) => HAdminConnectorTransform),
  },
  {
    path: '/',
    name: 'start',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/pages/start-page.vue'),
  },
  {
    path: '/mina/foretag',
    name: 'my-companies',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/pages/my-companies.vue'),
  },
  {
    path: '/mina/foretag/:organizationUid',
    name: 'my-company',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/pages/my-company.vue'),
  },
  {
    path: '/mina/foretag/:organizationUid/detaljer',
    name: 'my-company-details',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/pages/my-company-details.vue'),
  },
  {
    path: '/mina/pageande/arenden',
    name: 'my-cases',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/pages/my-cases.vue'),
  },
  {
    path: '/mina/fakturor',
    name: 'my-invoices',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/pages/my-invoices.vue'),
  },
  {
    path: '/mina/fastigheter',
    name: 'my-fastigheter',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/pages/my-properties.vue'),
  },
  {
    path: '/serveringspersonal/:servingplaceKey',
    name: 'servingstaff',
    meta: { authenticate: true, layout: layouts['blank-layout'] },
    component: () => import('/src/onify/citizen/pages/servingstaff.vue'),
  },
  {
    path: '/meddelande',
    name: 'send-message',
    meta: { authenticate: true, layout: layouts['blank-layout'] },
    component: () => import('/src/onify/citizen/pages/send-message.vue'),
  },
  {
    path: '/mina/batplatser',
    name: 'my-berths',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/pages/my-berths.vue'),
  },
  {
    path: '/profil',
    name: 'my-profile',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/pages/my-profile.vue'),
  },
  {
    path: '/mina/fullmakter',
    name: 'my-authorizations',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/pages/my-authorizations.vue'),
  },
  {
    path: '/form/custom',
    name: 'custom-form-page',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/forms/custom-form/custom-form-page.vue'),
  },
  {
    path: '/form/custom/dialog',
    name: 'custom-form-dialog',
    meta: { authenticate: true, layout: layouts['blank-layout'] },
    component: () => import('/src/onify/citizen/forms/custom-form/custom-form-dialog.vue'),
  },
  {
    path: '/mina/serveringstillstand/:permitId/andra',
    name: 'change-serving-permit',
    meta: { authenticate: true },
    component: () => import('/src/onify/citizen/pages/change-serving-permit.vue'),
  },
  {
    path: '/arende/:caseKey',
    name: 'view-case',
    meta: { authenticate: true, layout: layouts['blank-layout'] },
    component: () => import('/src/onify/citizen/pages/view-case.vue'),
  },
  {
    path: '/lista/objekt',
    name: 'list-items',
    meta: { authenticate: true, layout: layouts['blank-layout'] },
    component: () => import('/src/onify/citizen/pages/list-items-dialog.vue'),
  },
  {
    path: '/faktura/:invoiceKey',
    name: 'view-invoice',
    meta: { authenticate: true, layout: layouts['blank-layout'] },
    component: () => import('/src/onify/citizen/pages/view-invoice.vue'),
  },
];
